module.exports = __webpack_public_path__ + "static/media/lightbulb.a4db079b.svg";